import axios from "axios";
import Cookies from "js-cookie";

export interface UploadGuideReviewInput {
    file: File;
    guideId: string;
    month: number;
    year: number;
}

export interface UploadGuideReviewResult {
    id: string;
    guideId: string;
    month: number;
    year: number;
}

export const uploadGuideReview = async ({
    file,
    guideId,
    month,
    year,
}: UploadGuideReviewInput): Promise<UploadGuideReviewResult> => {
    const accessToken = Cookies.get("accessToken");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("guideId", guideId);
    formData.append("month", String(month));
    formData.append("year", String(year));

    const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/guide-reviews/upload`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: accessToken ? `Bearer ${accessToken}` : "",
            },
        }
    );

    return response.data;
};
